import { FILE_TYPES } from '../../../formFileTypesEnum';
import { VENDORS } from '../../../formQuestionsEnum';

export const GENERAL_AND_ADMIN_VENDOR_FIELDS = [
  {
    question: VENDORS.IT_VENDOR,
    title: 'IT',
    invoiceFileTypeId: FILE_TYPES.IT_PROVIDER_INVOICE,
    contractFileTypeId: FILE_TYPES.IT_PROVIDER_CONTRACT,
  },
  {
    question: VENDORS.COPIER_MACHINE_SERVICE_COMPANY,
    title: 'Copier machine service company',
    invoiceFileTypeId: FILE_TYPES.COPIER_MACHINE_SERVICE_COMPANY_INVOICE,
    contractFileTypeId: FILE_TYPES.COPIER_MACHINE_SERVICE_COMPANY_CONTRACT,
  },
  {
    question: VENDORS.COPIER_MACHINE_LEASE_COMPANY,
    title: 'Copier machine lease company',
    invoiceFileTypeId: FILE_TYPES.COPIER_MACHINE_LEASE_COMPANY_INVOICE,
    contractFileTypeId: FILE_TYPES.COPIER_MACHINE_LEASE_COMPANY_CONTRACT,
  },
  {
    question: VENDORS.MEDICAL_FORMS_VENDOR,
    title: 'Medical forms vendor',
    invoiceFileTypeId: FILE_TYPES.MEDICAL_FORMS_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.MEDICAL_FORMS_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.INTERNET_SERVICE_PROVIDER,
    title: 'Internet service provider',
    invoiceFileTypeId: FILE_TYPES.INTERNET_SERVICE_PROVIDER_INVOICE,
    contractFileTypeId: FILE_TYPES.INTERNET_SERVICE_PROVIDER_CONTRACT,
  },
  {
    question: VENDORS.BACKUP_INTERNET_PROVIDER,
    title: 'Backup internet provider',
    invoiceFileTypeId: FILE_TYPES.BACKUP_INTERNET_PROVIDER_INVOICE,
    contractFileTypeId: FILE_TYPES.BACKUP_INTERNET_PROVIDER_CONTRACT,
  },
  {
    question: VENDORS.PHONE_PROVIDER,
    title: 'Phone provider',
    invoiceFileTypeId: FILE_TYPES.PHONE_PROVIDER_INVOICE,
    contractFileTypeId: FILE_TYPES.PHONE_PROVIDER_CONTRACT,
  },
  {
    question: VENDORS.PHONE_SERVICE_COMPANY,
    title: 'Phone service provider',
    invoiceFileTypeId: FILE_TYPES.PHONE_SERVICE_PROVIDER_INVOICE,
    contractFileTypeId: FILE_TYPES.PHONE_SERVICE_PROVIDER_CONTRACT,
  },
  {
    question: VENDORS.SHREDDING_COMPANY,
    title: 'Shredding company',
    invoiceFileTypeId: FILE_TYPES.SHREDDING_COMPANY_INVOICE,
    contractFileTypeId: FILE_TYPES.SHREDDING_COMPANY_CONTRACT,
  },
  {
    question: VENDORS.DOCU_STORAGE_COMPANY,
    title: 'Docu storage company',
    invoiceFileTypeId: FILE_TYPES.DOCU_STORAGE_COMPANY_INVOICE,
    contractFileTypeId: FILE_TYPES.DOCU_STORAGE_COMPANY_CONTRACT,
  },
  {
    question: VENDORS.E_FAX_VENDOR,
    title: 'E-Fax vendor',
    invoiceFileTypeId: FILE_TYPES.EFAX_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.EFAX_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.BACKGROUND_CHECKS_VENDOR,
    title: 'Background checks vendor',
    invoiceFileTypeId: FILE_TYPES.BACKGROUND_CHECKS_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.BACKGROUND_CHECKS_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.OFFICE_SUPPLIES_VENDOR,
    title: 'Office supplies vendor',
    invoiceFileTypeId: FILE_TYPES.OFFICE_SUPPLIES_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.OFFICE_SUPPLIES_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.MARKETING_SUPPLIES_VENDOR,
    title: 'Marketing supplies vendor',
    invoiceFileTypeId: FILE_TYPES.MARKETING_SUPPLIES_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.MARKETING_SUPPLIES_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.CORPORATE_COMPLIANCE_VENDOR,
    title: 'Corporate compliance vendor',
    invoiceFileTypeId: FILE_TYPES.CORPORATE_COMPLIANCE_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.CORPORATE_COMPLIANCE_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.PURCHASING_SOFTWARE_VENDOR,
    title: 'Purchasing software',
    invoiceFileTypeId: FILE_TYPES.PURCHASING_SOFTWARE_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.PURCHASING_SOFTWARE_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.ACCOUNTANT_VENDOR,
    title: 'Accountant',
    invoiceFileTypeId: FILE_TYPES.ACCOUNTANT_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.ACCOUNTANT_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.AP_SOFTWARE_VENDOR,
    title: 'AP software vendor',
    invoiceFileTypeId: FILE_TYPES.AP_SOFTWARE_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.AP_SOFTWARE_VENDOR_CONTRACT,
  },

  {
    question: VENDORS.RFMS_SOFTWARE_VENDOR,
    title: 'RFMS Software',
    invoiceFileTypeId: FILE_TYPES.RFMS_SOFTWARE_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.RFMS_SOFTWARE_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.MAIL_AND_POSTAGE_VENDOR,
    title: 'Mail and postage vendor',
    invoiceFileTypeId: FILE_TYPES.MAIL_AND_POSTAGE_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.MAIL_AND_POSTAGE_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.HMO_CONTRACT_NEGOTIATION_PROVIDER,
    title: 'HMO contract negotiation provider',
    invoiceFileTypeId: FILE_TYPES.HMO_CONTRACT_NEGOTIATION_PROVIDER_INVOICE,
    contractFileTypeId: FILE_TYPES.HMO_CONTRACT_NEGOTIATION_PROVIDER_CONTRACT,
  },
  {
    question: VENDORS.UNEMPLOYMENT_LAWYER_VENDOR,
    title: 'Unemployment lawyer',
    invoiceFileTypeId: FILE_TYPES.UNEMPLOYMENT_LAWYER_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.UNEMPLOYMENT_LAWYER_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.TIME_AND_ATTENDANCE_SOFTWARE_VENDOR,
    title: 'Time and attendance software',
    invoiceFileTypeId: FILE_TYPES.TIME_AND_ATTENDANCE_SOFTWARE_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.TIME_AND_ATTENDANCE_SOFTWARE_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.WOUND_VAC_VENDOR,
    title: 'Wound vac vendor',
    invoiceFileTypeId: FILE_TYPES.WOUND_VAC_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.WOUND_VAC_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.AUDIT_VENDOR,
    title: 'Audit vendor',
    invoiceFileTypeId: FILE_TYPES.AUDIT_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.AUDIT_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.ACTIVITY_SUPPLIES_VENDOR,
    title: 'Activities supplies vendor',
    invoiceFileTypeId: FILE_TYPES.ACTIVITY_SUPPLIES_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.ACTIVITY_SUPPLIES_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.MDS_SCRUBBER_VENDOR,
    title: 'MDS scrubber',
    invoiceFileTypeId: FILE_TYPES.MDS_SCRUBBER_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.MDS_SCRUBBER_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.INSURANCE_VERIFICATION_SOFTWARE_VENDOR,
    title: 'Insurance verification software',
    invoiceFileTypeId: FILE_TYPES.INSURANCE_VERIFICATION_SOFTWARE_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.INSURANCE_VERIFICATION_SOFTWARE_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.PAYROLL_VENDOR,
    title: 'Payroll',
    invoiceFileTypeId: FILE_TYPES.PAYROLL_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.PAYROLL_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.VISITOR_SCREENING_VENDOR,
    title: 'Visitor screening',
    invoiceFileTypeId: FILE_TYPES.VISITOR_SCREENING_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.VISITOR_SCREENING_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.POLICY_AND_PROCEDURE_VENDOR,
    title: 'Policy and procedure',
    invoiceFileTypeId: FILE_TYPES.POLICY_AND_PROCEDURE_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.POLICY_AND_PROCEDURE_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.PHONE_ON_HOLD_VENDOR,
    title: 'Phone on hold',
    invoiceFileTypeId: FILE_TYPES.PHONE_ON_HOLD_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.PHONE_ON_HOLD_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.VENDING_MACHINE_SERVICES_VENDOR,
    title: 'Vending machine services',
    invoiceFileTypeId: FILE_TYPES.VENDING_MACHINE_SERVICES_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.VENDING_MACHINE_SERVICES_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.FACILITY_VAN_VENDOR,
    title: 'Facility van',
    invoiceFileTypeId: FILE_TYPES.FACILITY_VAN_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.FACILITY_VAN_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.PROMO_ITEMS_VENDOR,
    title: 'Promo items',
    invoiceFileTypeId: FILE_TYPES.PROMO_ITEMS_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.PROMO_ITEMS_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.MEDICAL_EQUIPMENT_PM_SERVICES_VENDOR,
    title: 'Medical equipment PM services',
    invoiceFileTypeId: FILE_TYPES.MEDICAL_EQUIPMENT_PM_SERVICES_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.MEDICAL_EQUIPMENT_PM_SERVICES_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.RECRUITMENT_ONBOARDING_VENDOR,
    title: 'Recruitment onboarding',
    invoiceFileTypeId: FILE_TYPES.RECRUITMENT_ONBOARDING_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.RECRUITMENT_ONBOARDING_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.EMPLOYEE_SCHEDULING_SOFTWARE_VENDOR,
    title: 'Employee scheduling software',
    invoiceFileTypeId: FILE_TYPES.EMPLOYEE_SCHEDULING_SOFTWARE_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.EMPLOYEE_SCHEDULING_SOFTWARE_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.REFERRAL_SOFTWARE_VENDOR,
    title: 'Referral software',
    invoiceFileTypeId: FILE_TYPES.REFERRAL_SOFTWARE_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.REFERRAL_SOFTWARE_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.PHONE_EQUIPMENT_SERVICE_PROVIDER,
    title: 'Phone equipment service provider',
    invoiceFileTypeId: FILE_TYPES.PHONE_EQUIPMENT_PROVIDER_INVOICE,
    contractFileTypeId: FILE_TYPES.PHONE_EQUIPMENT_PROVIDER_CONTRACT,
  },
  {
    question: VENDORS.PAPER_PLASTIC_VENDOR,
    title: 'Paper/plastic vendor',
    invoiceFileTypeId: FILE_TYPES.PAPER_PLASTIC_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.PAPER_PLASTIC_VENDOR_CONTRACT,
  },
];
